/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Output } from '@angular/core';
import { AmiDetailsTemplate } from 'src/app/@amiga-pyme/components/ami-details/ami-detail.template';

@Component({
  selector: 'pg-purchase-order-details',
  template: `
    <p-fieldset [legend]="legend" [toggleable]="true">
      <ami-details
        [settings]="settings"
        (action)="onReciveAction($event)"
      ></ami-details>
    </p-fieldset>
    <!-- 
    <pg-provider-select
      *ngIf="select.canBeDisplay"
      (selectedRowsEvent)="onSelected($event); prueba2 = $event"
    ></pg-provider-select>
     -->
    <pg-purchase-order-select
      *ngIf="select.canBeDisplay"
      (selectedRowsEvent)="onSelected($event)"
      [isInvoice]="isInvoice"
    ></pg-purchase-order-select>
  `
})
export class PurchaseOrderSelectDetailsComponent extends AmiDetailsTemplate {
  @Input() legend = 'Orden de Compra';
  @Input() data;
  @Input() isInvoice: boolean;
  // @Input() enab
  ngOnInit() {
    this.settings = {
      head: {
        title: '',
        subtitle: ''
      },
      body: {
        rows: [
          { header: 'Doc. Orden de Compra', field: 'numberDocument' },
          { header: 'Proveedor', field: 'providerName' },
          { header: 'Fecha de Entrega', field: 'delivery_at_short' }
        ]
      }
    };
    this.addActionSelect();
    this.onSelected(this.data);
  }
}

export class PurchaseOrderSelected {
  value: any;
  legend: any;
  items: any;
  constructor(legend = 'Orden de Compra') {
    this.value = null;
    this.legend = legend;
  }
  onSelect(row) {
    if (row) {
      this.value = row;
    }
  }

  onReset() {
    this.value = null;
  }

  getId() {
    return this.value?.id;
  }

  getId2() {
    return this.value?.providerId;
  }
  getItems() {
    this.items = this.value?.products;
    return this.value?.products;
  }

  getInfo() {
    return this.value;
  }

  setId(row) {
    if (row) {
      this.value = row;
    }
  }
}
